/**
 * @generated SignedSource<<ab1b330d67da8266ef66e888a921ac9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeEOYMessaging_viewer$data = {
  readonly tradeEOY2020: boolean | null;
  readonly " $fragmentType": "TradeEOYMessaging_viewer";
};
export type TradeEOYMessaging_viewer$key = {
  readonly " $data"?: TradeEOYMessaging_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeEOYMessaging_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "TradeEOYMessaging_viewer"
};

(node as any).hash = "0d2856027f23bcd89d9fa7b7ff6d8659";

export default node;
